// extracted by mini-css-extract-plugin
export default {"row":"MaterialRow_row__A6wHn"};